"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const project_1 = require("../../Abstract/Interfaces/project");
let MapTooltipNeedMapSection = class MapTooltipNeedMapSection extends vue_property_decorator_1.Vue {
    get scoreValue() {
        let tempScore = this.fieldStats.mean;
        if (tempScore < 0)
            return 0;
        tempScore = Math.round(tempScore);
        if (tempScore < 1)
            tempScore = 1;
        // console.log({
        //     typeScale: this.currentNeedMapCategory.typeScale, 
        //     mean: this.fieldStats.mean ?? -1,
        //     ceil: Math.ceil(this.fieldStats.mean) ?? -1,
        //     floor: Math.floor(this.fieldStats.mean) ?? -1,
        //     stats: this.fieldStats
        // });
        if (this.currentNeedMapCategory.typeScale === 'rank') {
            if (this.currentNeedMapCategory.reverseScale) {
                return Math.max(this.currentNeedMapCategory.getCuratedRank(tempScore), 1);
            }
            return tempScore;
        }
        else {
            if (this.currentNeedMapCategory.reverseScale) {
                return Math.max(100 - tempScore, 1);
            }
            return tempScore;
        }
    }
    get fieldStats() {
        var _a;
        let statsByDefault = {
            mean: -1,
            min: -1,
            max: -1
        };
        if (!((_a = this.currentGisField) === null || _a === void 0 ? void 0 : _a.needs_maps_results))
            return statsByDefault;
        let needMap = this.currentGisField.needs_maps_results.find(result => this.currentNeedMapCategory.slug.includes(result.category.slug)) || { results: undefined };
        let { stats } = needMap.results || { stats: undefined };
        return stats ? stats : statsByDefault;
    }
    get needMapTitle() {
        var _a;
        let titleByDefault = 'Need map not found';
        if (!((_a = this.currentGisField) === null || _a === void 0 ? void 0 : _a.needs_maps_results))
            return titleByDefault;
        let needMap = this.currentGisField.needs_maps_results.find(result => this.currentNeedMapCategory.slug.includes(result.category.slug)) || { category: { title: undefined } };
        return needMap.category.title || titleByDefault;
    }
    mainActionClicked() {
        this.$emit('mainActionClicked');
    }
    get currentGisField() {
        var _a;
        if (!((_a = this.currentProject) === null || _a === void 0 ? void 0 : _a.gisFields))
            return null;
        const field = this.currentProject.gisFields.find((item) => item.name === this.currentFieldName);
        return field;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapTooltipNeedMapSection.prototype, "currentNeedMapCategory", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapTooltipNeedMapSection.prototype, "currentFieldName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: project_1.AreaProjectDeliverable, default: new project_1.AreaProjectDeliverable({}) })
], MapTooltipNeedMapSection.prototype, "currentProject", void 0);
MapTooltipNeedMapSection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Tag: bmk_ui_framework_1.Tag,
            MetricRankTag: MetricRankTag_vue_1.default
        },
    })
], MapTooltipNeedMapSection);
exports.default = MapTooltipNeedMapSection;
